import type { App } from 'vue';
import type { Router } from 'vue-router';

import { TopLevelPagePlugin } from '@powerduck/components/app/vue-plugin-toplevelpage';
import { createApp as createCSRApp, createSSRApp } from 'vue';
import AppAgnosticFrameworkInitializer from './app-agnostic-framework-initializer';
import AppEntryComponent from './index';
import { AppRouter } from './router';

interface AppData {
	router: Router;
	app: App;
}

export default class AppAgnosticFactory {
	static create(): Promise<AppData> {
		return new Promise<AppData>((resolve) => {
			AppAgnosticFrameworkInitializer.init(() => {
				const ssr = false;
				const app = (ssr ? createSSRApp : createCSRApp)(AppEntryComponent);
				app.config.warnHandler = (
					msg,
					vm,
					trace,
				) => {
					if (msg.includes('was accessed during render but is not defined on instance')) {
						return;
					}

					console.warn(`[Vue warn]: ${msg}`, trace);
				};

				const router = AppRouter.currentRouter;
				app.use(router);
				app.use(TopLevelPagePlugin);
				resolve({ app, router });
			});
		});
	}
}
